<div (keydown)="onKeyPress($event)">
  <app-loading-overlay-full *ngIf="loading"></app-loading-overlay-full>
  <!-- <div class="d-flex justify-content-between align-items-center px-4 border-bottom w-100">
    <div class="d-flex flex-column">
      <h1 class="d-flex text-dark fw-bold my-1 fs-5">Take Member Photo</h1>
    </div>
    <div class="d-flex align-items-center top-of-modal py-2 py-md-1">

    </div>
  </div> -->
  <a (click)="activeModal.close()" class="rounded-4 bg-danger text-white icon-btn modal-close-icon">
    <i class="fs-4 bi bi-x fw-bold"></i>
  </a>
  <div class="w-100 mb-2">
    <div class="row">
      <div class="col-md-12">
        <div class="card-body">
          <div class="col-lg-12 p-0 m-0 text-center" *ngIf="!webcamImage">
            <div class="w-100 px-3 pb-1 pt-3 d-flex justify-content-center">
              <div class="camera-widget" ngbAutofocus>
                <webcam [allowCameraSwitch]="true" [width]="465" [ngClass]="'rounded-0'" [trigger]="trigger"
                  [trigger]="triggerObservable" [videoOptions]="videoOptions" (imageCapture)="handleImage($event)">
                </webcam>
              </div>
            </div>
            <div class="px-3 pt-2 border-top d-flex justify-content-center">
              <button (click)="triggerSnapshot()"
                class="btn btn-lg btn-dark text-center w-100 d-flex justify-content-center">
                <span><i class="bi bi-camera fw-bold me-2"></i> CAPTURE IMAGE</span>
              </button>
            </div>
          </div>
          <div class="col-lg-12 p-0 m-0 text-center" *ngIf="!!webcamImage">
            <div class="w-100 px-3 pb-1 pt-3 d-flex justify-content-center">
              <div class="rounded-2 border camera-result-widget">
                <img [src]="webcamImage!.imageAsDataUrl" class="w-100">
              </div>
            </div>
            <div class="px-3 pt-2 border-top d-flex gap-2">
              <button (click)="clearSnapshot()" class="btn btn-lg btn-danger d-flex w-100 justify-content-center">
                <span><i class="bi bi-arrow-clockwise fw-bold me-2"></i> Re-take Picture</span>
              </button>
              <button (click)="activeModal.close(getBlobFromWebcamImage())" class="btn btn-lg btn-dark d-flex w-100 justify-content-center">
                <span><i class="bi bi-check-all fw-bold me-2"></i> Save & Close</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
